import { useDebounceValue } from 'usehooks-ts'

import { useConversationSearch } from 'stores/useConversationSearchStore'

export const useDebouncedSearchValue = (): string => {
  const { searchValue } = useConversationSearch()
  const [debouncedSearchValue] = useDebounceValue(searchValue, 300)

  return debouncedSearchValue
}
